import { get } from 'core_main/request';
import { GetArticleByIdParameters } from 'core_main/sdk/get_articles/types';

import {
  validateArticlesSearchParameters,
  validateArticleByIdParameters,
  makeArticlesSearchEndpoint,
  makeArticleByIdEndpoint,
} from './helpers';
import { ArticlesSearchParameters } from './types';

export const fetchArticleById = (parameters: GetArticleByIdParameters) => {
  const validationError = validateArticleByIdParameters(parameters);

  if (validationError) {
    return Promise.reject(validationError);
  }

  return get(makeArticleByIdEndpoint(parameters));
};

export const searchArticlesByKnowledgeBaseId = (
  parameters: ArticlesSearchParameters,
) => {
  const validationError = validateArticlesSearchParameters(parameters);

  if (validationError) {
    return Promise.reject(validationError);
  }

  return get(makeArticlesSearchEndpoint(parameters));
};
